<template>
  <v-dialog v-model="alert" persistent width="auto">
    <v-card>
      <v-card-text>
        <v-col xs="12">
          <v-row class="mt-2">
            <v-alert type="error" class="mt-4" variant="tonal" border="bottom">
              {{ $t("delete_alert") }}
            </v-alert>
          </v-row>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <!--CANCEL-->
        <v-btn color="red-darken-1" variant="outlined" @click="cancel">
          {{ $t("no") }}
        </v-btn>
        <!--CONFIRM-->
        <v-btn
          color="green-darken-3"
          :loading="loading"
          variant="outlined"
          @click="confirm"
        >
          {{ $t("yes") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    alert: false,
    loading: false,
    content: null,
  }),
  methods: {
    open(content) {
      this.content = content;
      this.alert = true;
    },
    close() {
      this.content = null;
      this.loading = false;
      this.alert = false;
    },
    cancel() {
      this.$emit("cancelled", this.content);
      this.close();
    },
    confirm() {
      this.loading = true;
      this.$emit("confirmed", this.content);
    },
  },
};
</script>
